import {FC} from 'react';

export const GooglePlay: FC = () => {
    return (
        <svg
            width="112"
            height="39"
            viewBox="0 0 112 39"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.1068 9.50185C13.8802 9.74432 13.75 10.1175 13.75 10.6025V27.8516C13.75 28.3365 13.8802 28.7097 14.1153 28.9437L14.1767 28.9954L23.8832 19.3303V19.1132L14.1682 9.4502L14.1068 9.50185Z"
                fill="url(#paint0_linear_4327_392133)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.1126 22.565L23.875 19.3401V19.1145L27.1137 15.8896L27.1836 15.9329L31.0141 18.1003C32.1109 18.716 32.1109 19.7302 31.0141 20.3543L27.1836 22.5217C27.1825 22.5217 27.1126 22.565 27.1126 22.565Z"
                fill="url(#paint1_linear_4327_392133)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.1848 22.522L23.8773 19.2275L14.1094 28.9538C14.4662 29.3354 15.0665 29.3786 15.7377 29.0054L27.1848 22.522Z"
                fill="url(#paint2_linear_4327_392133)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.1848 15.933L15.7377 9.45799C15.0675 9.07636 14.4662 9.12802 14.1094 9.50964L23.8762 19.2264L27.1848 15.933Z"
                fill="url(#paint3_linear_4327_392133)"
            />
            <path
                opacity="0.2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.1143 22.4521L15.7455 28.8839C15.1103 29.2476 14.5439 29.2223 14.1786 28.8924L14.1172 28.9535L14.1786 29.0052C14.5439 29.3341 15.1103 29.3604 15.7455 28.9967L27.1926 22.5217L27.1143 22.4521Z"
                fill="#272747"
            />
            <path
                opacity="0.12"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.0104 20.2417L27.1016 22.4524L27.1714 22.522L31.002 20.3545C31.5504 20.0424 31.8204 19.6355 31.8204 19.2275C31.7854 19.6007 31.507 19.956 31.0104 20.2417Z"
                fill="#272747"
            />
            <path
                opacity="0.25"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.7351 9.57166L31.0127 18.2141C31.5093 18.4914 31.7877 18.8551 31.8312 19.2283C31.8312 18.8214 31.5612 18.4134 31.0127 18.1013L15.7351 9.45886C14.6383 8.83476 13.75 9.35449 13.75 10.6027V10.7155C13.75 9.46729 14.6383 8.956 15.7351 9.57166Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.5646 18.6808C35.5646 15.9177 37.897 13.668 40.672 13.668C42.2061 13.668 43.2976 14.2678 44.1213 15.049L43.1515 16.0147C42.5629 15.4644 41.7646 15.0374 40.6709 15.0374C38.6445 15.0374 37.0606 16.6619 37.0606 18.6797C37.0606 20.6975 38.6445 22.3242 40.6699 22.3242C41.9838 22.3242 42.7312 21.7992 43.2108 21.3205C43.6036 20.9294 43.8609 20.3675 43.9604 19.5969H40.672V18.2306H45.3008C45.3495 18.4752 45.3749 18.7683 45.3749 19.0856C45.3749 20.1114 45.0922 21.3838 44.1828 22.2894C43.2976 23.2065 42.169 23.6957 40.6709 23.6957C37.8949 23.6957 35.5625 21.4481 35.5625 18.6829L35.5646 18.6808ZM49.1165 17.2386C47.324 17.2386 45.8609 18.5964 45.8609 20.4656C45.8609 22.3252 47.323 23.6925 49.1165 23.6925C50.91 23.6925 52.37 22.3231 52.37 20.4645C52.37 18.5954 50.9089 17.2376 49.1165 17.2386ZM49.1165 22.4233C48.135 22.4233 47.287 21.6168 47.287 20.4666C47.287 19.3049 48.134 18.51 49.1165 18.51C50.0979 18.51 50.9449 19.3038 50.9449 20.4666C50.9449 21.6157 50.099 22.4233 49.1165 22.4233ZM56.2153 17.2386C54.4229 17.2386 52.9618 18.5964 52.9618 20.4656C52.9618 22.3252 54.4229 23.6925 56.2153 23.6925C58.0078 23.6925 59.4688 22.3231 59.4688 20.4645C59.4688 18.5954 58.0088 17.2376 56.2153 17.2386ZM56.2153 22.4233C55.2339 22.4233 54.3858 21.6168 54.3858 20.4666C54.3858 19.3049 55.2328 18.51 56.2153 18.51C57.1968 18.51 58.0448 19.3038 58.0448 20.4666C58.0448 21.6157 57.1968 22.4233 56.2153 22.4233ZM64.9277 17.4347V17.9597H64.879C64.5603 17.5791 63.9462 17.2376 63.1734 17.2376C61.5524 17.2376 60.0649 18.6565 60.0649 20.4793C60.0649 22.2873 61.5514 23.6946 63.1734 23.6946C63.9462 23.6946 64.5603 23.3531 64.879 22.962H64.9277V23.4258C64.9277 24.6603 64.2649 25.3213 63.1967 25.3213C62.3242 25.3213 61.7843 24.6972 61.563 24.1733L60.3222 24.6867C60.6779 25.5416 61.6244 26.5937 63.1956 26.5937C64.8642 26.5937 66.2765 25.6144 66.2765 23.2308V17.4336L64.9277 17.4347ZM63.2951 22.4233C62.3137 22.4233 61.4889 21.6031 61.4889 20.4793C61.4889 19.3428 62.3126 18.511 63.2951 18.511C64.2649 18.511 65.0262 19.3418 65.0262 20.4793C65.0272 21.6031 64.266 22.4233 63.2951 22.4233ZM67.2601 14.0106H68.6852V23.4986H67.2601V14.0106ZM72.5908 22.4233C71.8667 22.4233 71.35 22.0922 71.0207 21.446L75.3552 19.6591L75.2059 19.2922C74.937 18.5722 74.1133 17.2386 72.431 17.2386C70.7613 17.2386 69.3733 18.5469 69.3733 20.4666C69.3733 22.2746 70.7486 23.6936 72.5908 23.6936C74.0773 23.6936 74.937 22.7901 75.2927 22.263L74.1874 21.5303C73.8179 22.069 73.314 22.4243 72.5908 22.4233ZM72.4797 18.4857C73.044 18.4857 73.5225 18.7672 73.6824 19.1699L70.7836 20.3686C70.7476 19.1214 71.7544 18.4857 72.4797 18.4857Z"
                fill="#DFDFE8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M81.6101 14.0107H78.2031V23.4987H79.625V19.9049H81.6112C83.1877 19.9049 84.7377 18.7684 84.7377 16.9573C84.7377 15.1493 83.1887 14.0118 81.6133 14.0118L81.6101 14.0107ZM81.6472 18.5839H79.625V15.3306H81.6472C82.7102 15.3306 83.3158 16.2088 83.3158 16.9573C83.3158 17.6931 82.7102 18.5839 81.6472 18.5839ZM86.943 23.4987V14.0107H85.5211V23.4987H86.943ZM93.3304 23.4818V19.8448C93.3304 18.1601 92.0663 17.2208 90.4347 17.2208C89.4067 17.2208 88.3406 17.6731 87.8991 18.6735L89.1611 19.1975C89.4311 18.6735 89.9329 18.5017 90.4612 18.5017C91.196 18.5017 91.9434 18.9413 91.9551 19.7236V19.8216C91.6978 19.6751 91.1473 19.4547 90.4718 19.4547C89.1113 19.4547 87.7265 20.199 87.7265 21.5906C87.7265 22.8609 88.8424 23.6779 90.0928 23.6779C91.0499 23.6779 91.5761 23.251 91.9064 22.7513H91.9551V23.4839H93.3293L93.3304 23.4818ZM90.2653 22.4213C89.7995 22.4213 89.1494 22.1894 89.1494 21.6169C89.1494 20.8842 89.9594 20.6017 90.6581 20.6017C91.2838 20.6017 91.5771 20.7356 91.9583 20.919C91.8492 21.7708 91.1261 22.4108 90.2653 22.4213ZM98.3308 17.4285L96.7004 21.541H96.6517L94.9598 17.4285H93.4278L95.9645 23.1782L94.5172 26.3757H96.0005L99.9105 17.4285H98.3308Z"
                fill="#DFDFE8"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_4327_392133"
                    x1="23.0116"
                    y1="10.417"
                    x2="7.47228"
                    y2="14.5753"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00A0FF"/>
                    <stop
                        offset="0.007"
                        stopColor="#00A1FF"
                    />
                    <stop
                        offset="0.26"
                        stopColor="#00BEFF"
                    />
                    <stop
                        offset="0.512"
                        stopColor="#00D2FF"
                    />
                    <stop
                        offset="0.76"
                        stopColor="#00DFFF"
                    />
                    <stop
                        offset="1"
                        stopColor="#00E3FF"
                    />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_4327_392133"
                    x1="32.4414"
                    y1="19.2278"
                    x2="13.4837"
                    y2="19.2278"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFE000"/>
                    <stop
                        offset="0.409"
                        stopColor="#FFBD00"
                    />
                    <stop
                        offset="0.775"
                        stopColor="#FFA500"
                    />
                    <stop
                        offset="1"
                        stopColor="#FF9C00"
                    />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_4327_392133"
                    x1="25.3863"
                    y1="21.0197"
                    x2="12.9829"
                    y2="41.9849"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF3A44"/>
                    <stop
                        offset="1"
                        stopColor="#C31162"
                    />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_4327_392133"
                    x1="11.6505"
                    y1="3.76332"
                    x2="17.184"
                    y2="13.1267"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#32A071"/>
                    <stop
                        offset="0.069"
                        stopColor="#2DA771"
                    />
                    <stop
                        offset="0.476"
                        stopColor="#15CF74"
                    />
                    <stop
                        offset="0.801"
                        stopColor="#06E775"
                    />
                    <stop
                        offset="1"
                        stopColor="#00F076"
                    />
                </linearGradient>
            </defs>
        </svg>
    );
};
